import { api, fetchInterceptor } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

const channelsApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1GroupsByGroupIdChannels: {
      providesTags: ['Group_Channels', 'USER_CHANGED'],
      async onCacheEntryAdded(
        _,
        { dispatch, cacheDataLoaded, cacheEntryRemoved },
      ) {
        await cacheDataLoaded
        const off = fetchInterceptor.on({
          url: [
            '/api/v1/groups/:groupId/channels',
            '/api/v1/groups/:groupId/channels/:channelId',
          ],
          method: ['POST', 'DELETE'],
          callback: () => dispatch(api.util.invalidateTags(['Group_Channels'])),
        })
        await cacheEntryRemoved
        off()
      },
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1GroupsByGroupIdChannelsPublic: {
      providesTags: ['Group_Channels', 'USER_CHANGED'],
      async onCacheEntryAdded(
        _,
        { dispatch, cacheDataLoaded, cacheEntryRemoved },
      ) {
        await cacheDataLoaded
        const off = fetchInterceptor.on({
          url: [
            '/api/v1/groups/:groupId/channels',
            '/api/v1/groups/:groupId/channels/:channelId',
          ],
          method: ['POST', 'PUT', 'DELETE'],
          callback: () => dispatch(api.util.invalidateTags(['Group_Channels'])),
        })
        await cacheEntryRemoved
        off()
      },
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1GroupsByGroupIdChannelsLookup: {
      extraOptions: {
        initialDataKey: 'channel',
      },
      providesTags: ['Group_Channels', 'USER_CHANGED'],
    },
    postApiV1GroupsByGroupIdChannels: {
      invalidatesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1GroupsByGroupIdChannelsAutoSubscribe: {
      providesTags: ['Group_Channels', 'USER_CHANGED'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    putApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribe: {
      invalidatesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(
          queryFulfilled,
          'Channel subscription updated successfully',
        )
      },
    },
    getApiV1GroupsByGroupIdChannelsPrimary: {
      providesTags: ['Group_Channels', 'USER_CHANGED'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    putApiV1GroupsByGroupIdChannelsAndChannelIdPrimary: {
      invalidatesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(
          queryFulfilled,
          'Primary channel changed successfully',
        )
      },
    },
    putApiV1GroupsByGroupIdChannelsAndChannelId: {
      invalidatesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    putApiV1GroupsByGroupIdChannelsAndChannelIdUsername: {
      invalidatesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    deleteApiV1GroupsByGroupIdChannelsAndChannelId: {
      invalidatesTags: ['Group_Channels'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(
          queryFulfilled,
          'Channel deleted successfully',
        )
      },
    },
  },
})

export const {
  useGetApiV1GroupsByGroupIdChannelsLookupQuery,
  useGetApiV1GroupsByGroupIdChannelsQuery,
  useLazyGetApiV1GroupsByGroupIdChannelsQuery,
  usePostApiV1GroupsByGroupIdChannelsMutation,
  useGetApiV1GroupsByGroupIdChannelsPublicQuery,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdMutation,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdUsernameMutation,
  useGetApiV1GroupsByGroupIdChannelsAutoSubscribeQuery,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribeMutation,
  useGetApiV1GroupsByGroupIdChannelsPrimaryQuery,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdPrimaryMutation,
  useDeleteApiV1GroupsByGroupIdChannelsAndChannelIdMutation,
} = channelsApi
